import http from '@core/fetch'

const get = url => query => http(url, { body: query })

export default {
  // 获取优惠标签列表
  getPreferentialList: get('/p/wedding/Admin/APIMarkMappers/preferentialList'),

  // 编辑优惠标签
  editExclusiveOffers: body =>
    http.post('/p/wedding/Admin/APIMarkMappers/editPreferentialMarks', {
      body,
      ignore: []
    }),

  // 设置专属优惠信息
  setDiscountInfo: names =>
    http.post('/hms/hljHotel/appApi/admin/hotelPreferential/editPreferential', {
      body: { content: names, status: 3 }
    }),
  // 获取优惠列表
  getDiscountList: () =>
    http.get('/hms/hljHotel/appApi/admin/hotelPreferential/details', {})
}
